export const LOCALIZED_DATETIME_FORMAT = "L, LTS" as const;
export const LOCALIZED_DATETIME_FORMAT_SHORT = "L, LT" as const;

export const LOCALIZED_DATE_FORMAT = "L" as const;

export const LOCALIZED_TIME_FORMAT = "LTS" as const;
export const LOCALIZED_TIME_FORMAT_SHORT = "LT" as const;

export const LOCALIZED_DATETIME_NO_YEAR = "D MMM, LT" as const;

export const ISO_FORMAT = "YYYY-MM-DDTHH:mm:ssZ" as const;
